// UI stav zjednodušené sekce /station-charts (varianta B), viz
// doc/plans/deploy-variant-b-station-charts.md. Samostatné od mapSettings v stationStore.js
// (ten je pro plnou mapu s toolbarem a přepínáním vizualizací) — zjednodušená mapa má jen
// jediný natvrdo daný vizuální mód, ukládá se tu jen viditelnost legendy (mapa) a aktivní
// tab (detail stanice) — obojí má přežít refresh stránky.
import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export const useStationChartsMapStore = create(
  persist(
    set => ({
      showLegend: true,
      setShowLegend: (showLegend) => set({ showLegend }),
      activeTab: 'graf',
      setActiveTab: (activeTab) => set({ activeTab }),
    }),
    {
      name: 'station-charts-map',
      storage: createJSONStorage(() => localStorage),
    }
  )
)
